import { render, staticRenderFns } from "./QuestionTypeFreeText.vue?vue&type=template&id=79f2ce5a"
import script from "./QuestionTypeFreeText.vue?vue&type=script&lang=js"
export * from "./QuestionTypeFreeText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports